import { useState, useEffect } from "react";
import OrganisationService from "../../services/OrganisationService/OrganisationService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

function useOrganisationFetch(organisationId) {
  const [organisation, setOrganisation] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchOrganisation() {
      if (typeof organisationId === "undefined") {
        setIsLoading(false);
        return;
      }
      setIsLoading(true);
      const newOrganisation = await OrganisationService.getOrganisation(organisationId);
      setIsLoading(false);

      const hasOrganisation =
        newOrganisation &&
        typeof newOrganisation === "object" &&
        Object.keys(newOrganisation).length > 0;

      if (hasOrganisation) {
        setOrganisation(newOrganisation);
      } else {
        toast.error("Unable to find organisation.");
        navigate("/organisations");
      }
    }

    fetchOrganisation();
  }, [organisationId, navigate]);

  return {
    organisation,
    isLoading,
  };
}

export default useOrganisationFetch;
